import React from "react";
import PropTypes from "prop-types";

const CountRenderer = ({ label, count }) => {
  return (
    <div className="count-renderer">
      <div className="count-label">{label}</div>
      <div className="count">{count}</div>
    </div>
  );
};

CountRenderer.propTypes = {
  label: PropTypes.string,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CountRenderer;
